<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { isActionVisible } from "@/components/StickyNote/internal/ActionMenu/actions";
import { boardKey } from "@/components/board/injectKeys";
import { injectStrict } from "@/utils/vue";

import EnablingTeam from "./EnablingTeam.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => isActionVisible("depend", card, board.value));
</script>

<template>
  <ActionMenuDropdown v-if="isVisible" :action="cardActions.setDepend">
    <EnablingTeam />
  </ActionMenuDropdown>
</template>
